// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputContainer_f5HqT {
    position : relative;
    width : 100%;
}

.cameraIcon_E2VAp { 
    position : absolute; 
    right : 0px;
    top : 50%;
    transform: translateY(-50%);
  }`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/r4k/views/installGateway/DeviceInput.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,2BAA2B;EAC7B","sourcesContent":[".inputContainer {\n    position : relative;\n    width : 100%;\n}\n\n.cameraIcon { \n    position : absolute; \n    right : 0px;\n    top : 50%;\n    transform: translateY(-50%);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `inputContainer_f5HqT`,
	"cameraIcon": `cameraIcon_E2VAp`
};
export default ___CSS_LOADER_EXPORT___;
